var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerBtnIconClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 44,
    height: 1,
    transform: "rotate(45 2 0)",
    fill: "#111748"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 1,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 32 0)",
    fill: "#111748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerBtnIconClose);
export default __webpack_public_path__ + "static/media/burgerBtnIconClose.74ae598c8d065d5cfe63c340adb49457.svg";
export { ForwardRef as ReactComponent };